import { z } from 'zod';

/**
 * Wyszukiwanie globalne (⌘K, Figma 13 Szukaj 3035:4973): usługa `search.global` (packages/core/src/modules/search).
 * Klienci, kontakty, projekty, zadania (numer i tytuł), zasoby Utrzymania (nazwa, adres), a od Fali 2 także wiedza
 * (tytuł i treść), spotkania (tytuł) i oferty (tytuł, bez kwot). Bez wielkości liter
 * i polskich znaków („szkolka” → „Szkółka”), każde słowo frazy musi pasować (do nazwy rekordu albo nazwy jego
 * klienta), ranking: dokładne trafienie > początek > początek słowa > zawiera. Tylko moduły i rekordy z zakresu
 * osoby; bez archiwum. Od kompozycji Fali 4 także wiadomości (moduł Inbox: temat, nadawca — imię i adres; jeden wynik
 * na wątek, link do wątku; wiadomość bez klienta tylko z zakresem „Wszyscy klienci”). Od kompozycji Fali 5 także
 * przebiegi AI (moduł Agenci: tytuł, polecenie, podsumowanie, powód błędu, tytuł zadania, klient — „po problemie”,
 * w zakresie osoby; link do przebiegu `/agenci/<id>`; bez kosztów).
 */

export const SEARCH_RESULT_TYPES = [
  'client',
  'contact',
  'project',
  'task',
  'asset',
  'knowledge',
  'meeting',
  'offer',
  'message',
  'agent_run',
] as const;
export type SearchResultType = (typeof SEARCH_RESULT_TYPES)[number];

export const SEARCH_MIN_LENGTH = 2;

export const globalSearchInput = z.object({
  q: z.string().trim().max(100, { message: 'Najwyżej 100 znaków' }),
  limit: z.number().int().min(1).max(30).default(10),
  types: z.array(z.enum(SEARCH_RESULT_TYPES)).min(1).optional(),
});
export type GlobalSearchInput = z.input<typeof globalSearchInput>;

export interface SearchHit {
  type: SearchResultType;
  id: string;
  title: string;
  /** podpis: „klient”, „projekt · REA Nieruchomości”, „zadanie #12 · REA Nieruchomości” */
  subtitle: string;
  /** ścieżka SPA */
  to: string;
  client: { id: string; name: string; color: string | null } | null;
  /**
   * Adresat akcji „Napisz do: …” w ⌘K (Figma 13, kompozycja Fali 4): kontakt z adresem — dla kontaktu on sam, dla
   * klienta jego kontakt główny. Brak adresu = brak akcji.
   */
  contact?: { name: string; email: string } | null;
  /** ranking (większy = lepszy) */
  score: number;
  /** tytuł napisała osoba z zewnątrz (zgłoszenie z portalu klienta) — dla AI dane, nie polecenia */
  untrusted?: boolean;
}

export interface GlobalSearchResult {
  q: string;
  items: SearchHit[];
}
